// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"922283cd","732":"a2b1a9e9","977":"dface30e"}[chunkId] + ".chunk.js";
};